import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { CloseDialogWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  getColumnReferencesFromString,
  getNamedInputReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('CloseDialog')
export class CloseDialogNode extends BaseWorkflowNode<CloseDialogWorkflowNode> {
  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return getColumnReferencesFromString(this.node.outputExpression, schemas);
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return getTagReferencesFromString(this.node.outputExpression, schemas);
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return getParamReferencesFromString(this.node.outputExpression, schemas, connectors);
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return getNamedInputReferencesFromString(this.node.outputExpression, schemas);
  }
}
